import Vue from 'vue';
let VNodePrototype; // init later
const isVNode = value => !!value && Object.getPrototypeOf(value) === VNodePrototype;
const builtinFallback = {
  'text'(value) {
    // Vue2
    const el = this.$createElement('');
    el.text = String(value);
    el.isComment = false;
    return el;
  },
  'fa-icon'(value) {
    return this.$createElement('i', {
      class: value
    });
  }
};
export const MaybeVNode = Vue.extend({
  name: 'MaybeVNode',
  functional: true,
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true
    },
    fallback: {
      type: [String, Function],
      default: 'text'
    }
  },
  render(h, context) {
    // -------------------------
    if (!VNodePrototype) VNodePrototype = Object.getPrototypeOf(h('div'));
    // -------------------------
    let {
      value,
      fallback
    } = context.props;
    if (typeof value === 'function') value = value.call(context.parent);
    if (!value && value !== 0) return h();
    if (typeof fallback === 'string') fallback = builtinFallback[fallback];
    if (!isVNode(value)) value = fallback.call(context.parent, value);
    return value;
  }
});
//# sourceMappingURL=MaybeVNode.js.map
